module.exports = __webpack_public_path__ + "static/img/number07.c68cdf11.png";